import React, { useState, useEffect } from 'react';
import { FiCheck } from 'react-icons/fi';
import { api } from '../api';

export default function UserAccess() {
  const [data, setData] = useState(null);
  const [toast, setToast] = useState('');

  useEffect(() => { api('/access').then(setData).catch((e) => setToast(e.message)); }, []);

  if (!data) return <div className="empty">{toast || 'Loading…'}</div>;

  // Flatten modules into ordered columns: parent then its children
  const cols = [];
  data.modules.forEach((p) => {
    cols.push({ ...p, isParent: true });
    p.children.forEach((c) => cols.push({ ...c, isParent: false }));
  });

  return (
    <div>
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Configuration</div>
          <h1>User Access</h1>
          <div className="count">{data.users.length} users · who can access which modules</div>
        </div>
      </div>

      <div className="table-card" style={{ overflowX: 'auto' }}>
        <table className="data access-table">
          <thead>
            <tr>
              <th style={{ position: 'sticky', left: 0, background: '#FBFAF8', zIndex: 2 }}>User</th>
              <th>Role</th>
              {cols.map((c) => (
                <th key={c.id} className={c.isParent ? 'col-parent' : 'col-child'}>
                  {c.isParent ? c.label : <span style={{ fontWeight: 400 }}>{c.label}</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.users.map((u) => {
              const set = new Set(u.accessible_module_ids);
              return (
                <tr key={u.id} style={{ opacity: u.is_active ? 1 : 0.5 }}>
                  <td style={{ position: 'sticky', left: 0, background: '#fff', fontWeight: 600, zIndex: 1 }}>
                    {u.name}{!u.is_active && <span className="pill pill-muted" style={{ marginLeft: 6 }}>inactive</span>}
                  </td>
                  <td style={{ color: 'var(--muted)' }}>{u.role_name}</td>
                  {cols.map((c) => (
                    <td key={c.id} style={{ textAlign: 'center' }}>
                      {set.has(c.id)
                        ? <FiCheck style={{ color: '#3B7A4E' }} />
                        : <span style={{ color: '#D8D2C7' }}>·</span>}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="page-desc" style={{ marginTop: 14, fontSize: 13 }}>
        Access is determined by each user’s role. To change what a role can access, edit the role’s permissions in Configuration → Permissions.
      </p>
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
